module.exports = __webpack_public_path__ + "static/person1-c20052f27d1a38fb12a537c2573a710b.png";